import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Competencies from './components/Competencies';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [heroVersion] = useState(2); // 버전2를 기본으로 설정

  return (
    <div className="App">
      <Navbar />
      <Hero heroVersion={heroVersion} />
      <About />
      <Services />
      <Competencies />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
